import { PureComponent } from 'react';

class PopoverComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }

    componentDidMount() {
        document.addEventListener('click', this.onOutsideClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onOutsideClick, true);
    }

    onOutsideClick = (event) => {
        const domNode = this.node;
        if (!domNode || !domNode.contains(event.target)) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.setState({ expanded: false });
    }

    openPopover = () => {
        this.setState({ expanded: true });
    }

    togglePopover = (e) => {
        if (this.state.expanded) {
            this.closePopover(e);
        } else {
            this.openPopover(e);
        }
    }
}

export default PopoverComponent;



// WEBPACK FOOTER //
// ./~/rp-react-common/PopoverComponent/PopoverComponent.jsx